import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemObj, sessionGetItemStr } from '../../../utils/sessionHelpers'
import DucumentManagementWidget from '../../../widgets/auditWidgets/ducumentManagementWidgets/DucumentManagementWidget'
import { getDocumentManageIa } from '../../../redux/actions/IaDucumentManagement'

export default function DucumentManagement() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectId = sessionStorage.getItem('projectId')
  const auditInfo = sessionGetItemObj('auditInfo')

  const mockSchema = {
    affectedRows: 5,
    message: 'Successfully',
    success: true,
    didError: false,
    errorMessage: null,
    model: {
      header: 'จัดการแบบฟอร์มสำหรับตรวจสอบโหลดแบบฟอร์ม',
      subHeader: '',
      viewMode: true,
      searchForm: {
        title: 'ค้นหา',
        documentName: {
          name: 'documentName',
          label: 'ชื่อเอกสาร',
          value: '',
          validators: [],
        },
        button: {
          add: 'เพิ่มแบบฟอร์ม',
          search: 'ค้นหา',
          cancel: 'ยกเลิก',
        },
      },
      addForm: {
        title: 'เพิ่มข้อมูล',
        documentName: {
          name: 'documentName',
          label: 'ชื่อเอกสาร',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอก ชื่อเอกสาร ',
            },
          ],
        },
        attachFiles: {
          name: 'attachFiles',
          header: 'แนบไฟล์',
          buttonText: 'แนบไฟล์',
          fileSize: 50,
          fileType: '.docx, .xlsx, .pdf',
          description: ['แนบไฟล์'],
          value: [],
          id: null,
        },
        button: {
          save: 'บันทึก',
          cancel: 'ยกเลิก',
        },
      },
      values: [
        {
          id: '1',
          fileName: '1111',
          filePath: '1111',
          fileType: '.docx',
        },
      ],
    },
  }

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    // setSchema(mockSchema.model)
    setIsLoading(true)
    startLoading()
    try {
      const response = await getDocumentManageIa()
      console.log('resssss => ', response)

      if (response) {
        setSchema(response)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  // console.log('schema => ', schema)

  if (error) {
    return (
      <SidebarProposal isAudit>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAudit>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAudit>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi isShowGoButton />

        <DucumentManagementWidget schema={schema} />
        <br />
      </SidebarProposal>
    </div>
  )
}
